import React, { useState } from 'react';
import * as S from './CardsList.styles';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { sleep } from '@/utils/helpers';
import { Card } from '@/mock-data/cards';
import { CardsItem } from '@/components/Profile/Cards/CardsItem';
import { AddCardButton } from '@/components/Profile/Cards/AddCardButton';
import { CardSettings } from '@/components/Profile/Cards/CardSettings';
import { MAX_PAYMENT_CARDS } from '@/components/Profile/Cards/Cards.constants';

interface CardsListProps {
  cards: Card[];
}

export const CardsList: React.FC<CardsListProps> = ({ cards }) => {
  const [selectedCard, setSelectedCard] = useState<null | Card>(null);
  const [isOpen, toggle] = useToggleOpenState();

  async function openCardDrawer(card: Card) {
    setSelectedCard(card);
    await sleep(0);
    toggle(true);
  }

  return (
    <>
      <S.Box>
        {cards.map(card => (
          <CardsItem key={card.id} card={card} openDrawer={openCardDrawer} />
        ))}

        {cards.length < MAX_PAYMENT_CARDS && <AddCardButton />}
      </S.Box>

      {selectedCard && (
        <CardSettings isOpen={isOpen} close={toggle} card={selectedCard} />
      )}
    </>
  );
};
